// Angular Files
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule } from '@angular/router';

// Component
import { PublicPortalHeaderComponent } from './public-portal-header.component';

// Directives
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
    declarations: [
        PublicPortalHeaderComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,
        MatTooltipModule,
        DirectivesModule
    ],
    exports: [
        PublicPortalHeaderComponent
    ]
})
export class PublicPortalHeaderModule { }